import { FormFieldsDeadline } from '../../../Form'
import {
  REQUESTS_EDIT_DUE_DATE_FIELD_NAME,
  REQUESTS_EDIT_DUE_DATE_FIELD_NAME_WITHOUT_DATE,
} from '../RequestEditDueDateModal.constants'

function RequestEditDueDateModalDateField({
  deadlineFieldName = REQUESTS_EDIT_DUE_DATE_FIELD_NAME,
  deadlineLabel = 'Request.EditDeadlineFieldDatePlaceholderKey',
  inputDateLabel = 'Request.EditDeadlineFieldDateLabelKey',
  inputTimeLabel = 'Request.EditDeadlineFieldTimeLabelKey',
  timeLabel = 'Request.EditDeadlineFieldTimePlaceholderKey',
  withoutDeadlineFieldName = REQUESTS_EDIT_DUE_DATE_FIELD_NAME_WITHOUT_DATE,
  withoutDeadlineLabel = 'Request.WithoutDeadlineLabelKey',
  ...restProps
}) {
  return (
    <FormFieldsDeadline
      {...restProps}
      deadlineFieldName={deadlineFieldName}
      inputDateLabel={inputDateLabel}
      inputDatePlaceholder={deadlineLabel}
      inputTimeLabel={inputTimeLabel}
      inputTimePlaceholder={timeLabel}
      withoutDeadlineFieldName={withoutDeadlineFieldName}
      withoutDeadlineLabel={withoutDeadlineLabel}
    />
  )
}

export default RequestEditDueDateModalDateField
